export default {
    /** Le panneau de traduction partagé, quel que soit l'écran qui l'affiche. */
    translation: {
        placeholder: 'Translation…',
        emptySource: '(empty)',
        maxLengthExceeded: 'This field cannot exceed {{max}} characters.',
    },
    description: 'This is a multilingual application using i18next.',
    change_language: 'Change language {{lng}}',
    current_language: 'Current language {{lng}}',
    back: 'Back',
    backToTemplate: 'Back to template',
    backToQuestionnaire: 'Back to questionnaire',
    backToDashboard: 'Back to dashboard',
    next: 'Next',
    previous: 'Previous',
    showingResults: 'Showing {{start}}-{{end}} of {{total}} results',
    pageWithNumber: 'Page {{page}}',
    save: 'Save',
    saving: 'Saving...',
    loading: 'Loading...',
    launch360Evaluation: 'Launch 360 Feedback',
    viewAll: 'View All',
    viewMore: 'View More',
    viewLess: 'View Less',
    edit: 'Edit',
    delete: 'Delete',
    evaluation360: 'Evaluation Dashboard',
    template: 'Feedback model',
    reviewee: 'Reviewee',
    reviewer: 'Reviewer',
    reviewees: 'Reviewees',
    reviewVerb: 'Review',
    cancel: 'Cancel',
    add: 'Add',
    question: 'Question',
    questions: 'Questions',
    questionType: 'Question Type',
    evaluationType: 'Questionnaire',
    optional: 'Optional',
    unassigned: 'None selected',
    skill: 'Competency',
    advancedOptions: 'Advanced Options',
    translate: 'Translate',
    sortBy: 'Sort By',
    from: 'From',
    to: 'To',
    // The two marks of the "FROM ... -> TO ..." pattern (`components/DateRangeFields`), drawn in
    // small caps by the component. They are the same on every screen that lets a date range be
    // picked, so they are written here once.
    dateRange: {
        from: 'From',
        to: 'To',
    },
    department: 'Department',
    jobTitle: 'Job Title',
    address: 'Address',
    company: 'Company',
    office: 'Office',
    employeeLevel: 'Employee Level',
    ageGroup: 'Age Group',
    tenure: 'Tenure',
    manager: 'Manager',
    managers: 'Managers',
    yes: 'Yes',
    no: 'No',
    stronglyDisagree: 'Strongly disagree',
    stronglyAgree: 'Strongly agree',
    settings: 'Settings',
    update: 'Update',
    mandatory: 'Mandatory',
    noResponses: 'No responses available',
    noResults: 'No result',
    close: 'Close',
    select: 'Select',
    filter: 'Filter',
    employeeAttribute: 'Employee attribute',
    search: 'Search',
    clearSearch: 'Clear search',
    searchResultsCount: '{{count}} result',
    searchResultsCount_one: '{{count}} result',
    searchResultsCount_other: '{{count}} results',
    response: 'Response',
    responses: 'Responses',
    vote: 'Vote',
    votes: 'Votes',
    active: 'Active',
    inactive: 'Inactive',
    draft: 'Draft',
    templateStatus: 'Template Status',
    deactivate: 'Deactivate',
    activate: 'Activate',
    rename: 'Rename',
    confirm: 'Confirm',
    low: 'Low',
    high: 'High',
    reviewerWithCount: '{{count}} reviewer',
    reviewersWithCount: '{{count}} reviewers',
    profileInfoBadgesAriaLabel: 'Profile information badges',
    respondedOutOfInvited_one: '{{count}} of {{invited}} responded',
    respondedOutOfInvited_other: '{{count}} of {{invited}} responded',
    reviewersSectionAriaLabel: 'Reviewers section',
    evaluationDateAriaLabel: 'Evaluation date',
    profile: 'Profile',
    reviewType: {
        evaluation360: '360 Feedback',
        managerEvaluation: '{{managerLabelCapitalized}} Assessment',
        selfEvaluation: 'Self-Assessment',
    },
    selectDate: 'Select Date',
    anonymous: 'Anonymous',
    error: 'Error',
    draftSavedAt: 'Draft Saved on {{time}}',
    ok: 'Ok',
    attention: 'Attention',
    deleteConfirmTitle: 'Confirm delete',
    deleteConfirmMessage: 'Are you sure you want to delete this item?',
    deleteQuestionMessage:
        'Deleting a question is permanent. You will not be able to retrieve past survey responses for deleted questions. Consider deactivating the question if you want to keep survey responses. Do you want to permanently delete the question?',
    demoRestriction:
        'Since you are currently using a demo account, you cannot post this message for now.',
    languages: {
        en: 'English',
        fr: 'French (Canada)',
        fr_FR: 'French (France)',
        es: 'Spanish',
        vi: 'Vietnamese',
        tl: 'Tagalog',
        de: 'German',
        pt: 'Portuguese',
        zh: 'Chinese (Mandarin)',
        hu: 'Hungarian',
        it: 'Italian',
        th: 'Thai (Thailand)',
        tr: 'Turkish',
        pt_BR: 'Brazilian Portuguese',
        ro: 'Romanian',
        cs: 'Czech',
        he: 'Hebrew',
        sk: 'Slovak',
        km: 'Cambodian',
        bg: 'Bulgarian',
        nl: 'Dutch',
        pl: 'Polish',
        lv: 'Latvian',
        lt: 'Lithuanian',
        et: 'Estonian',
        sr: 'Serbian',
        sl: 'Slovenian',
        hr: 'Croatian',
        zh_Hant: 'Traditional Chinese',
        ja: 'Japanese',
        sw: 'Swahili',
        ar: 'Arabic',
    },
    status: 'Status',
    competencies: 'Competencies',
    all: 'All',
    create: 'Create',
    deactivated: 'Deactivated',
    deleted: 'Deleted',
    notDefined: 'n.d',
    missingTranslation: '⚠️ Missing translation',
    unsavedChanges: {
        title: 'Unsaved changes',
        message: 'Your changes will be lost if you continue without saving.',
        confirm: 'Continue without saving',
        cancel: 'Stay on this page',
        keepEditing: 'Keep editing',
    },
};
